module.exports = __webpack_public_path__ + "img/happytable_info3.305e2f6f.jpg";